import React from "react";
import "./style.css";

export default function AccessDeniedPage({
  title = "غير مصرح بالدخول",
  message = "عذراً، ليس لديك صلاحية الوصول إلى هذه الصفحة.",
  onBack = null,
  actions = [],
  illustration = true,
}) {
  return (
    <main className="adp-root">
      <div className="adp-card">
        <div className="adp-grid">
          <section className="adp-left">
            <div className="adp-header">
              <div className="adp-icon" aria-hidden>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2L4 5v6c0 5 4 9 8 11 4-2 8-6 8-11V5l-8-3z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 11v3"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h1 className="adp-title">{title}</h1>
            </div>

            <p className="adp-message">{message}</p>

            <div className="adp-actions">
              {onBack && (
                <button onClick={onBack} className="adp-btn adp-btn-outline">
                  العودة
                </button>
              )}

              {actions.map(function (a, i) {
                return a.href ? (
                  <a key={i} href={a.href} className="adp-btn adp-btn-primary">
                    {a.label}
                  </a>
                ) : (
                  <button
                    key={i}
                    onClick={a.onClick}
                    className="adp-btn adp-btn-primary"
                  >
                    {a.label}
                  </button>
                );
              })}

              {/* <a href="/" className="adp-home">
                الصفحة الرئيسية
              </a> */}
            </div>

            <div className="adp-tip">
              تأكّد من تسجيل الدخول بحساب يملك الصلاحيات أو تواصل مع مسؤول
              النظام.
            </div>
          </section>

          <aside className="adp-right" aria-hidden>
            {illustration && (
              <div className="adp-illustration">
                <div className="adp-lock">
                  <svg
                    viewBox="0 0 120 120"
                    xmlns="http://www.w3.org/2000/svg"
                    className="access-denied-icon"
                  >
                    <rect
                      x="6"
                      y="44"
                      width="108"
                      height="64"
                      rx="10"
                      stroke="currentColor"
                      strokeWidth="4"
                      fill="none"
                    />
                    <path
                      d="M36 44v-8a24 24 0 0 1 48 0v8"
                      stroke="currentColor"
                      strokeWidth="4"
                      fill="none"
                    />
                    <circle
                      cx="60"
                      cy="76"
                      r="8"
                      stroke="currentColor"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                </div>
              </div>
            )}
          </aside>
        </div>

        <footer className="adp-footer">
          © {new Date().getFullYear()} مؤسسة عبد الحميد شومان — جميع الحقوق
          محفوظة.
        </footer>
      </div>
    </main>
  );
}
